import { render, staticRenderFns } from "./MiniproLiveForm.vue?vue&type=template&id=1434a1c6&scoped=true&"
import script from "./MiniproLiveForm.vue?vue&type=script&lang=js&"
export * from "./MiniproLiveForm.vue?vue&type=script&lang=js&"
import style0 from "./MiniproLiveForm.vue?vue&type=style&index=0&id=1434a1c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1434a1c6",
  null
  
)

export default component.exports